import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, signInWithPopup } from "firebase/auth";
import { getAnalytics } from "firebase/analytics";

/**
 * Firebase configuration (NEW PROJECT)
 */
const firebaseConfig = {
  apiKey: "AIzaSyAd84iSV00JaH6TAy0mE8YoIcHYKdzu1Mw",
  authDomain: "guardian-shield-af7a1.firebaseapp.com",
  projectId: "guardian-shield-af7a1",
  storageBucket: "guardian-shield-af7a1.firebasestorage.app",
  messagingSenderId: "863493450973",
  appId: "1:863493450973:web:e9eb947aad8915b106ff34",
  measurementId: "G-2SWRDT0S5N"
};

/**
 * Initialize Firebase
 */
const app = initializeApp(firebaseConfig);

/**
 * Firebase Auth
 */
const auth = getAuth(app);
const provider = new GoogleAuthProvider();

/**
 * Firebase Analytics
 * Guarded so it doesn't break SSR / older browsers
 */
let analytics;
if (typeof window !== "undefined") {
  analytics = getAnalytics(app);
}

/**
 * Exports
 */
export { auth, provider, signInWithPopup, analytics };
